
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-294aa0c6!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./tariffspanel.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./tariffspanel.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-294aa0c6!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./tariffspanel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/dq-ui/packages/tariffspanel/src/tariffspanel.vue
// module id = 478
// module chunks = 36